import React from 'react';

const ChevDownIcon = () => {
  return (
    <svg
      width="12"
      height="7"
      viewBox="0 0 12 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.29996 1.09L6.00347 4.62531L9.70698 1.09C10.0792 0.734648 10.6806 0.734648 11.0528 1.09C11.4251 1.44535 11.4251 2.01939 11.0528 2.37474L6.67163 6.55697C6.29937 6.91232 5.69803 6.91232 5.32577 6.55697L0.944559 2.37474C0.5723 2.01939 0.5723 1.44535 0.944559 1.09C1.31682 0.743759 1.92771 0.734648 2.29996 1.09Z"
        fill="#14607A"
      />
      <path
        d="M2.29996 1.09L6.00347 4.62531L9.70698 1.09C10.0792 0.734648 10.6806 0.734648 11.0528 1.09C11.4251 1.44535 11.4251 2.01939 11.0528 2.37474L6.67163 6.55697C6.29937 6.91232 5.69803 6.91232 5.32577 6.55697L0.944559 2.37474C0.5723 2.01939 0.5723 1.44535 0.944559 1.09C1.31682 0.743759 1.92771 0.734648 2.29996 1.09Z"
        fill="#14607A"
      />
    </svg>
  );
};

export default ChevDownIcon;
